module.exports = __webpack_public_path__ + "a6c7e3596b43304339f169b263268225.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/company/banner-blue.jpg
// module id = ./assets/images/company/banner-blue.jpg
// module chunks = 0